import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  connect() {
    if (this.hasButtonTarget && navigator.share) {
      this.buttonTarget.classList.add('is-active')
    }
  }

  async share({ params: { title, text, url } }) {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url })
      } catch (error) {
        if (error.name !== 'AbortError') {
          throw error
        }
      }
    }
  }
}
